import {createContext} from 'react'

export const OrderDataContext = createContext({});
